import React from 'react';

type Tone = 'blue' | 'purple';

const PALETTE: Record<
  Tone,
  { shieldTop: string; shieldBottom: string; line: string; docEdge: string; check: string }
> = {
  blue: {
    shieldTop: '#6A8DF4',
    shieldBottom: '#5577EE',
    line: '#A9B7EC',
    docEdge: '#D9E0F5',
    check: '#2E8BF0',
  },
  purple: {
    shieldTop: '#9677F4',
    shieldBottom: '#835FF0',
    line: '#B9A8F4',
    docEdge: '#E1D9FB',
    check: '#7A52EE',
  },
};

/** Decorative shield + policy document, drawn to match the BizCover banner mock-ups. */
const BizCoverIllustration: React.FC<{ tone?: Tone; className?: string }> = ({
  tone = 'blue',
  className,
}) => {
  const c = PALETTE[tone];
  const gid = `bizcoverShield-${tone}`;
  return (
    <svg
      className={className}
      viewBox='0 0 120 120'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      aria-hidden='true'
      focusable='false'
    >
      <defs>
        <linearGradient id={gid} x1='10' y1='4' x2='70' y2='110' gradientUnits='userSpaceOnUse'>
          <stop stopColor={c.shieldTop} />
          <stop offset='1' stopColor={c.shieldBottom} />
        </linearGradient>
      </defs>
      {/* Shield */}
      <path d='M45 4 82 18v34c0 27-16 46-37 56C24 98 8 79 8 52V18L45 4Z' fill={`url(#${gid})`} />
      {/* Document */}
      <rect x='56' y='41' width='50' height='62' rx='6' fill='#fff' />
      <rect
        x='56.75'
        y='41.75'
        width='48.5'
        height='60.5'
        rx='5.25'
        stroke={c.docEdge}
        strokeWidth='1.5'
      />
      <rect x='64' y='54' width='34' height='4' rx='2' fill={c.line} />
      <rect x='64' y='64' width='34' height='4' rx='2' fill={c.line} />
      <rect x='64' y='74' width='24' height='4' rx='2' fill={c.line} />
      {/* Check badge */}
      <circle cx='102' cy='100' r='13' fill={c.check} />
      <circle cx='102' cy='100' r='13' stroke='#fff' strokeWidth='3' />
      <path
        d='m96.5 100 3.8 3.8 7.2-7.6'
        stroke='#fff'
        strokeWidth='2.8'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default BizCoverIllustration;
